import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getCase } from "slices/casesSlice";
import { getCompanyFlows } from "slices/companyFlowsSlice";
import { getDispute } from "slices/disputeSlice";
import SingleDispute from "./SingleDispute";
export default function SingleDisputeContainer() {
  let { disputeId } = useParams();

  const {
    profile: { profile, loading: profileLoading },
    disputes: { loading: disputeLoading, activeDispute: activeDispute },
    cases: { loading: caseLoading, activeCase: activeCase },
    companyFlows: { loading: companyFlowsLoading, companyFlows },
  } = useSelector((state) => state, shallowEqual);

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getDispute(disputeId));
    dispatch(getCase(disputeId));
    dispatch(getCompanyFlows());
  }, []);

  const passObjects = {
    profile,
    activeDispute,
    activeCase,
    companyFlows,
  };
  const loading =
    profileLoading ||
    caseLoading ||
    disputeLoading ||
    companyFlowsLoading ||
    isEmpty(activeDispute) ||
    isEmpty(activeCase);

  if (profile.profile_type && !loading)
    return <SingleDispute {...passObjects} />;
  else return <CircularCenteredLoader />;
}
